module.exports = __webpack_public_path__ + "img/fire.b31ef677.svg";